import axios from 'axios';

const api = axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}/api`,
	headers: {
		'Content-Type': 'application/json',
		'ngrok-skip-browser-warning': 'true',
	},
});

const authHeaders = (token) => ({
	Authorization: `Bearer ${token}`,
});

export const createLifetimePaymentIntent = (payload, token) =>
	api.post('/stripe/customer-portal/create-lifetime-payment-intent', payload, {
		headers: authHeaders(token),
	});

export const confirmLifetimePurchase = (payload, token) =>
	api.post('/stripe/customer-portal/confirm-lifetime-purchase', payload, {
		headers: authHeaders(token),
	});
